import type { GeoJSON } from 'geojson';
import proj4 from 'proj4';
import { reproject } from 'reproject';

const sweRef99Proj = '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs';

function fromSweRef99GeoJson<G extends GeoJSON>(geojson: G): G {
    return reproject(geojson, sweRef99Proj, proj4.WGS84, proj4);
}

function toSweRef99GeoJson<G extends GeoJSON>(geojson: G): G {
    return reproject(geojson, proj4.WGS84, sweRef99Proj, proj4);
}

function toSweRef99(coordinates: [number, number]): [number, number] {
    if (Number.isNaN(coordinates[0]) || Number.isNaN(coordinates[1])) return null;
    return proj4(proj4.WGS84, sweRef99Proj, coordinates);
}

function fromSweRef99(coordinates: [number, number]): [number, number] {
    if (!coordinates || Number.isNaN(Number.parseFloat(coordinates[0].toString())) || Number.isNaN(Number.parseFloat(coordinates[1].toString())))
        return null;
    return proj4(sweRef99Proj, proj4.WGS84, coordinates);
}

export { fromSweRef99, fromSweRef99GeoJson, sweRef99Proj, toSweRef99, toSweRef99GeoJson };
